/**
 * 区分 contactChannelType（contact_messages.contact_channel_type）
 * 出典：要件書 5.2
 */
export const CONTACT_CHANNEL_TYPE_VALUES = ['email', 'phone', 'meeting'] as const;

export type ContactChannelType = (typeof CONTACT_CHANNEL_TYPE_VALUES)[number];

export const CONTACT_CHANNEL_TYPE_LABELS: Readonly<Record<ContactChannelType, string>> = {
  email: 'メール',
  phone: '電話',
  meeting: '会議',
};
